export default __webpack_public_path__ + "static/media/AKM_1.f34a8afb.png";